import React, { useContext, useState } from 'react';
import { Select } from 'antd';
import { useMutation } from 'react-query';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import { useAllClasses } from '../../NecttosComp/APICaller/queryHooks';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

const exportPdf = async ({ olddata, setLoading }) => {
	try {
		const instance = await getAxiosTokenInstance();
		const { collegeId, classId } = olddata;

		const resp = await instance.post(
			'/college/reportGeneration/electoralRoll',
			{ collegeId, classId },
			{
				responseType: 'blob',
			},
		);

		if (resp.data.statusCode === 400) {
			setLoading(false);
			throw new Error(resp.data.message || 'API Error');
		}

		return resp.data;
	} catch (error) {
		setLoading(false);
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};
const { Option } = Select;

const ElectoralRoll = ({ onClose }) => {
	const { collegeId } = useContext(FirebaseContext);
	const [custom, setCustom] = useState(false);
	const [stateData, setStateData] = useState({});
	const [loading, setLoading] = useState(false);
	const allClasses = useAllClasses({ needAll: false, classOnly: false });

	const exportPdfMutation = useMutation(exportPdf);
	const onExportExam = async () => {
		try {
			setLoading(true);
			const { classId, className } = stateData;
			const link = document.createElement('a');
			link.target = '_blank';
			link.download = `${className.replace(/\./g, '')} (ER)`;

			const pdfData = await exportPdfMutation.mutateAsync({ olddata: { collegeId, classId }, setLoading });
			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
			link.click();

			setLoading(false);
			onClose();
		} catch (e) {
			// Handle error
		}
	};

	return (
		<Main title='Electoral Roll' height='50%' width='50%'>
			<Header>
				<div>
					<label className='text-2xl font-bold dark:text-white'>Electoral Roll</label>
				</div>
				
				<div className='justify-end flex'>
					<Instruction keyId={'electoralRoll'}/>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>
			<Body>
				<div className='flex flex-col items-center justify-center'>
					{loading ? (
						<LoadingAnimation dark />
					) : (
						<div className='flex flex-col items-center justify-center'>
							<label className='text-2xl font-bold dark:text-white'>Electoral Roll</label>
							<label className='text-2xl font-bold dark:text-white'>11:59 PM 10-10-2023</label>

							<div className='flex items-center dark:text-white'>
								<label style={{ fontSize: 30 }}>
									<input type='checkbox' style={{ height: 20, width: 20, marginRight: 10 }} defaultChecked={custom} onChange={() => setCustom(!custom)} />
									Custom
								</label>
							</div>

							<div className='w-full h-full'>
								<Input2
									type={custom ? 'text' : 'drop'}
									fieldName={custom ? 'Enter the Adminssion No:' : 'select class'}
									className='w-full'
									style={{ overflow: 'hidden' }}
									state={stateData}
									setState={setStateData}
									placeholder='Select Class'
									options={allClasses?.data}
									{...(!custom && {
										returnKey: 'classId',
										optionDisplay: 'className',
										optionKey: 'classId',
										didntShowKey: true,
									})}
								/>
							</div>
						</div>
					)}
					<Button type='refresh' onClick={onExportExam}>
						Electoral Roll PDF
					</Button>
				</div>
			</Body>
		</Main>
	);
};

export default ElectoralRoll;
